export default __webpack_public_path__ + "static/footer_img-0f1f1b857bbd2bb03e3ffbe44b8ff15e.svg";